import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function BoxIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <g clipPath="url(#clip0_95_516)">
        <path
          d="M31 3.04545C31 1.92182 30.0782 1 28.9545 1H18.7273V9.18182C18.7273 10.6873 17.5055 11.9091 16 11.9091C14.4945 11.9091 13.2727 10.6873 13.2727 9.18182V1H3.04545C1.91909 1 1 1.92182 1 3.04545V28.9545C1 30.0809 1.91909 31 3.04545 31H28.9545C30.0782 31 31 30.0809 31 28.9545V3.04545Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_95_516">
          <rect x="1" y="1" width="30" height="30" rx="6" fill="currentColor" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
}
